import React from 'react'
import Title from './Title';
import Image from '../images/nmz.png'
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa6';
import Bubbles from './Bubbles';

const About = () => {
  return (
    <section id="about" className="relative bg-primary-dark py-24 overflow-hidden noise-overlay">
      <div className="absolute inset-0 gradient-mesh pointer-events-none" />
      <Bubbles count={6} />

      {/* Floating decorative elements */}
      <div className="absolute top-20 right-20 w-32 h-32 border border-accent/5 rounded-full animate-float-slow pointer-events-none hidden sm:block" />
      <div className="absolute bottom-20 left-16 w-20 h-20 bg-accent/3 rounded-full blur-xl animate-float pointer-events-none" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <Title>About Me</Title>
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 mt-12 items-center">
          {/* Text Content */}
          <div
            className="p-6 lg:p-8 glass-card rounded-2xl hover-glow card-shine"
            data-aos="fade-right"
            data-aos-duration="800"
          >
            <h2 className="text-accent font-semibold text-xl mb-4 flex items-center gap-2">
              <span className="w-8 h-0.5 bg-accent/60 inline-block" />
              Hello!
            </h2>
            <p className="text-gray leading-relaxed text-sm lg:text-base">
              Chief Technology Officer at WeTech with extensive experience
              architecting scalable web platforms, leading engineering teams, and building
              products that drive business growth. Specialized in React, Node.js, Laravel,
              and end-to-end product delivery.
            </p>
            <Link
              to="/about"
              className="inline-flex items-center mt-6 text-sm text-accent hover:text-white transition-all duration-300 group magnetic-btn px-4 py-2 rounded-lg hover:bg-accent/10"
            >
              See More
              <FaArrowRight className="ml-2 group-hover:translate-x-2 transition-transform duration-300" />
            </Link>
          </div>

          {/* Image - Large upscale */}
          <div className="flex justify-center" data-aos="fade-left" data-aos-duration="800">
            <div className="relative group">
              {/* Animated border */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-accent/20 via-transparent to-accent/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-sm" />

              {/* Image - Large */}
              <div className="relative w-full max-w-sm lg:max-w-md aspect-square rounded-2xl overflow-hidden border border-primary-border group-hover:border-accent/30 transition-all duration-500 group-hover:shadow-glow-lg">
                <img
                  src={Image}
                  alt="Nang Myintzu — CTO at WeTech"
                  className="w-full h-full object-cover object-top scale-110 pt-2"
                  loading="lazy"
                />
              </div>

              {/* Floating accent */}
              <div className="absolute -bottom-4 -right-4 w-16 h-16 border border-accent/20 rounded-xl rotate-12 group-hover:rotate-6 transition-transform duration-500" />
              <div className="absolute -top-3 -left-3 w-8 h-8 bg-accent/10 rounded-lg -rotate-12 group-hover:-rotate-6 transition-transform duration-500" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
